require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-does-the-gdpr-mean-for-e-commerce-businesses.json") })
        }
      }, "path---blog-what-does-the-gdpr-mean-for-e-commerce-businesses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-does-the-gdpr-mean-for-e-commerce-businesses!./.cache/json/blog-what-does-the-gdpr-mean-for-e-commerce-businesses.json
// module id = 512
// module chunks = 231608221292675